import { useEffect, useState } from "react";
import { toast } from "react-toastify";

import Button from "../../../componentes/button/button";
import DropDown from "../../../componentes/dropdown/dropdown";

import AjusteComissaoService from "../../../services/resource/AjusteComissaoService";
import Textarea from "../../../componentes/input/textarea";
import FilialService from "../../../services/resource/filialService";
import Input from "../../../componentes/input/input";
import DateMasked from "../../../componentes/input/DateMasked";
import { ANOS, MESES } from "../../../utils/options";

const initialValues = {
    filialId: null,
    transporte: "",
    tipo: "IGNORAR_RETORNO",
    motivo: "",
    isDl: null,
    clienteId: null,
    codigoRetorno: null,
    ano: null,
    mes: null,
};

function AjusteRetornos({
    onClose,
    onSuccess,
    transportes = [],
    defaultValues = {},
    showFilial = true,
    showTransporte = true
}) {
    const ajusteService = new AjusteComissaoService();
    const filialService = new FilialService();

    const [form, setForm] = useState(initialValues);

    const [loading, setLoading] = useState(false);
    const [erros, setErros] = useState(false);
    const [filiais, setFiliais] = useState([]);

    useEffect(() => {
        document.title = "MyDash | Ajuste de Comissão";

        filialService.listar().then(res => setFiliais(res.data));
    }, []);

    const setCampo = (campo, valor) => {
        setForm(prev => ({
            ...prev,
            [campo]: valor
        }));
    };

    const validar = () => {

        if (!form.tipo) return false;
        if (!form.motivo) return false;
        if (!form.codigoRetorno) return false;
        if (!form.ano) return false;
        if (!form.mes) return false;

        if (showFilial && !form.filialId) return false;

        return true;
    };

    const handleSalvar = async () => {

        setErros(true);

        if (!validar()) {
            toast.error("Preencha os campos obrigatórios.");
            return;
        }

        setLoading(true);

        try {

            const response = await ajusteService.ajustarRetorno(form);

            toast.success("Ajuste solicitado com sucesso!");

            if (onSuccess) {
                onSuccess(response.data);
            }

            if (onClose) {
                onClose();
            }

        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    return (

        <div className="flex flex-col gap-5 pt-4 w-full space-y-6">

            <div className={`p-1 grid grid-cols-2 md:grid-cols-5 gap-2`}>
                <DropDown
                    label="Filial"
                    required
                    filter={false}
                    optionLabel="nome"
                    optionValue="id"
                    options={filiais}
                    value={form.filialId}
                    onChange={e => setCampo("filialId", e.value)}
                />

                <DropDown
                    label="Tipo de Ajuste"
                    required
                    optionLabel="label"
                    optionValue="value"
                    options={[{ label: "Ignorar Retorno", value: "IGNORAR_RETORNO" }]}
                    filter={false}
                    value={form.tipo}
                    onChange={e => setCampo("tipo", e.value)}
                    error={form.tipo === null && erros}
                    touched={erros}
                    disabled
                />

                <Input
                    label="Código do Retorno"
                    value={form.codigoRetorno}
                    onChange={e => setCampo("codigoRetorno", e.target.value)}
                    error={!form.codigoRetorno && erros}
                    touched={erros}
                    disabled={form.filialId === null}
                />

                <DropDown
                    label="Ano"
                    type="date"
                    filter={false}
                    options={ANOS}
                    value={form.ano}
                    onChange={e => setCampo("ano", e.target.value)}
                    error={!form.ano && erros}
                    touched={erros}
                    disabled={form.filialId === null}
                />

                
                <DropDown
                    label="Mes"
                    type="date"
                    filter={false}
                    options={MESES}
                    value={form.mes}
                    onChange={e => setCampo("mes", e.target.value)}
                    error={!form.mes && erros}
                    touched={erros}
                    disabled={form.filialId === null}
                />

                <div className="md:col-span-5">
                    <Textarea
                        label="Motivo do Ajuste"
                        value={form.motivo}
                        onChange={e => setCampo("motivo", e.target.value)}
                        error={!form.motivo && erros}
                        touched={erros}
                        disabled={form.filialId === null}
                    />

                </div>

            </div>

            <div className="flex justify-end border-t border-border items-end">

                <div className="flex justify-end gap-3 items-end pt-3">

                    <Button
                        label="Cancelar"
                        variant="gray"
                        onClick={onClose}
                        iconLeft="fa fa-arrow-left"
                    />

                    <Button
                        label="Solicitar Ajuste"
                        variant="indigo"
                        loading={loading}
                        onClick={handleSalvar}
                        iconLeft="fa fa-save"
                    />

                </div>

            </div>

        </div>
    );
}

export default AjusteRetornos;